import script from "./adjustmentreport.vue?vue&type=script&setup=true&lang=js"
export * from "./adjustmentreport.vue?vue&type=script&setup=true&lang=js"

import "./adjustmentreport.vue?vue&type=style&index=0&id=c8034892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8034892"]])

export default __exports__